import { AUTH0_TENANT_CLAIM } from 'app/constants';

export const ApiInterceptorModule = angular
    .module('app.services.interceptors.apiInterceptor', [
        'ngRaven'
    ]).factory('apiInterceptor', (
        $q,
        Raven,
        auth0AuthService,
        jwtHelper
    ) => {
        function getErrorMetadata(rejection) {
            let metadata = {};
            let cause = '';

            if (rejection) {
                rejection.config = rejection.config || {};

                metadata = {
                    error: {
                        response: rejection.data,
                        status: rejection.status,
                        method: rejection.config.method,
                        url: rejection.config.url,
                        headers: rejection.config.headers,
                        payload: rejection.config.data
                    }
                };
                if (rejection.data && rejection.data.error) {
                    cause = `${rejection.data.error} - ${rejection.data.error_description || ''}`;
                }
            }
            return {
                cause,
                metadata
            };
        }

        function shouldNotIntercept(url) {
            const baseUrl = process.env.BASE_API_URL;
            const themeUrl = `${baseUrl}/marketplace`;
            const customDomainUrl = `${baseUrl}/admin/customdomains`;

            return (url.indexOf(baseUrl) === -1 &&
                    url.indexOf(themeUrl) === -1 &&
                    url.indexOf(process.env.EXPIRE_CACHE_URL) === -1 &&
                    url.indexOf(process.env.ONBOARDING_API_URL) === -1 &&
                    url.indexOf(customDomainUrl) === -1) ||
                url.indexOf(`${baseUrl}/plans`) !== -1;
        }

        function getDecodedJWT(token) {
            if (token) {
                return jwtHelper.decodeToken(token);
            }
            return null;
        }

        function getTenantId(decoded) {
            if (decoded) {
                const tenantId = decoded[AUTH0_TENANT_CLAIM] || decoded.tenant;
                return tenantId;
            }
        }

        return {
            requestError(rejection) {
                let errorMetadata = getErrorMetadata(rejection);
                Raven.captureMessage('Failed $http request', { extra: errorMetadata });
                return $q.reject(rejection);
            },

            responseError(rejection) {
                let errorMetadata = getErrorMetadata(rejection);
                Raven.captureMessage('Failed $http request', { extra: errorMetadata });
                if (rejection.status === 403
                    && rejection.config.url
                    && rejection.config.url.includes(process.env.BASE_API_URL)
                ) {
                    return auth0AuthService.unauthenticatedHandler();
                }

                return $q.reject(rejection);
            },

            request: (config) => {
                if (shouldNotIntercept(config.url)) return config;
                return auth0AuthService.getTokenSilently().then((accessToken) => {
                    if (!config.bypassAuth) {
                        config.headers.Authorization = `Bearer ${accessToken}`;
                    }

                    const decoded = getDecodedJWT(accessToken);
                    const tenantId = getTenantId(decoded);
                    config.headers['x-mat-tenant'] = tenantId;

                    return config;
                });
            }
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/interceptors/api.interceptor.js